import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import gentsImg from '../Assets/mens.webp';
import ladiesImg from '../Assets/ladies.jpg';
import { API_BASE } from '../../config/api';
import './ShopByRecipient.css';

const SLIDE_INTERVAL_MS = 3500;
const FADE_DURATION_MS = 900;
const FALLBACK_MEN_IMAGES = [gentsImg];
const FALLBACK_WOMEN_IMAGES = [ladiesImg];

const normalizeImageList = (images, fallbackImages) => {
  const cleanedImages = Array.isArray(images)
    ? images.map((image) => String(image || '').trim()).filter(Boolean)
    : [];

  return cleanedImages.length ? cleanedImages : fallbackImages;
};

const RecipientCardSlider = ({ images, alt }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [previousIndex, setPreviousIndex] = useState(null);

  useEffect(() => {
    setCurrentIndex(0);
    setPreviousIndex(null);
  }, [images]);

  useEffect(() => {
    if (images.length <= 1) {
      return undefined;
    }

    const timer = setTimeout(() => {
      setPreviousIndex(currentIndex);
      setCurrentIndex((currentIndex + 1) % images.length);
    }, SLIDE_INTERVAL_MS);

    return () => clearTimeout(timer);
  }, [currentIndex, images]);

  useEffect(() => {
    if (previousIndex === null) {
      return undefined;
    }

    const timer = setTimeout(() => {
      setPreviousIndex(null);
    }, FADE_DURATION_MS);

    return () => clearTimeout(timer);
  }, [previousIndex]);

  return (
    <div className="sbr-card-media">
      {previousIndex !== null && previousIndex !== currentIndex && (
        <img
          key={`previous-${previousIndex}-${images[previousIndex]}`}
          src={images[previousIndex]}
          alt={alt}
          className="sbr-card-img sbr-card-img-previous"
        />
      )}
      <img
        key={`current-${currentIndex}-${images[currentIndex]}`}
        src={images[currentIndex]}
        alt={alt}
        className="sbr-card-img sbr-card-img-current"
      />
    </div>
  );
};

const ShopByRecipient = () => {
  const navigate = useNavigate();
  const [sliderImages, setSliderImages] = useState({
    menImages: FALLBACK_MEN_IMAGES,
    womenImages: FALLBACK_WOMEN_IMAGES
  });

  useEffect(() => {
    let active = true;

    fetch(`${API_BASE}/shop-by-recipient-section`)
      .then((res) => {
        if (!res.ok) {
          throw new Error('Failed to fetch Shop By Recipient images');
        }
        return res.json();
      })
      .then((data) => {
        if (!active) {
          return;
        }

        setSliderImages({
          menImages: normalizeImageList(data?.menImages, FALLBACK_MEN_IMAGES),
          womenImages: normalizeImageList(data?.womenImages, FALLBACK_WOMEN_IMAGES)
        });
      })
      .catch(() => {});

    return () => {
      active = false;
    };
  }, []);

  return (
    <section className="sbr-section">
      <h2 className="sbr-heading">Shop For Someone Special</h2>
      <div className="sbr-cards">
        <div
          className="sbr-card"
          onClick={() => navigate('/store?product=GENTS%20RING')}
        >
          <RecipientCardSlider images={sliderImages.menImages} alt="Jewelry for Him" />
          <div className="sbr-card-overlay">
            <div className="sbr-card-content">
              <span className="sbr-label">For</span>
              <h3 className="sbr-title">Mr.</h3>
              <button className="sbr-btn">Shop Now &rarr;</button>
            </div>
          </div>
        </div>

        <div
          className="sbr-card"
          onClick={() => navigate('/store?product=LADIES%20RING')}
        >
          <RecipientCardSlider images={sliderImages.womenImages} alt="Jewelry for Her" />
          <div className="sbr-card-overlay">
            <div className="sbr-card-content">
              <span className="sbr-label">For</span>
              <h3 className="sbr-title">Ms.</h3>
              <button className="sbr-btn">Shop Now &rarr;</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShopByRecipient;
